import { render, staticRenderFns } from "./FactMatch.vue?vue&type=template&id=1ff39964&"
import script from "./FactMatch.vue?vue&type=script&lang=js&"
export * from "./FactMatch.vue?vue&type=script&lang=js&"
import style0 from "./FactMatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff39964')) {
      api.createRecord('1ff39964', component.options)
    } else {
      api.reload('1ff39964', component.options)
    }
    module.hot.accept("./FactMatch.vue?vue&type=template&id=1ff39964&", function () {
      api.rerender('1ff39964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/GameModes/Social/FactMatch.vue"
export default component.exports